import React from 'react';
import AppTable from '@/components/atoms/AppTable';
import type { ColumnsType } from 'antd/es/table';
import type { VisitClinicConsent } from '@/types/visitClinic.types';

interface Props {
  consents: VisitClinicConsent[];
}

/**
 * 同意書情報 section — read-only table of consent records.
 */
const VisitClinicConsentSection: React.FC<Props> = ({ consents }) => {
  const columns: ColumnsType<VisitClinicConsent> = [
    { title: 'No.', dataIndex: 'serial_number', width: 60 },
    { title: '傷病名', dataIndex: 'injury_name', width: 140 },
    { title: '同意日', dataIndex: 'consent_date', width: 100 },
    { title: '初療年月日', dataIndex: 'first_treatment_date', width: 110 },
    { title: '要加療開始日', dataIndex: 'treatment_term_from', width: 110 },
    { title: '要加療終了日', dataIndex: 'treatment_term_to', width: 110 },
  ];

  return (
    <div>
      <AppTable
        dataSource={consents}
        columns={columns}
        rowKey={(record) =>
          `${record.serial_number ?? ''}-${record.consent_date ?? ''}-${record.injury_name ?? ''}`
        }
        pagination={false}
      />
    </div>
  );

};

export default VisitClinicConsentSection;
